import { render } from "./LigipaasetavusLogiSisseLeht.vue?vue&type=template&id=5d732a44&ts=true"
import script from "./LigipaasetavusLogiSisseLeht.vue?vue&type=script&lang=ts"
export * from "./LigipaasetavusLogiSisseLeht.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__